import React from "react";
import {
  skeletonCard,
  skeletonTitle,
  skeletonCount,
  skeletonBase,
} from "./skeletonStyles_vanilla.css";
import { metricItem } from "./styles_vanilla.css";

export const WorkflowCardSkeleton: React.FC = () => {
  return (
    <div className={`${metricItem} ${skeletonCard}`}>
      <div className={`${skeletonBase} ${skeletonCount}`} />
      <div className={`${skeletonBase} ${skeletonTitle}`} />
    </div>
  );
};

export default WorkflowCardSkeleton;
